import { Alert, Grid, Typography } from '@mui/material'
import type { FC } from 'react'

import PageContainer from '@/components/UI/PageContainer'
import { genericErrorMessage } from '@/utils/error'

interface ErrorPageProps {
  message?: string
}

const ErrorPage: FC<ErrorPageProps> = ({ children, message = genericErrorMessage }) => (
  <PageContainer
    pageContent={
      <Grid
        container
        sx={{ height: '100vh', alignItems: 'center', justifyContent: 'center' }}
      >
        <Alert severity="error">
          <Typography component="p">{message}</Typography>
          {children}
        </Alert>
      </Grid>
    }
  />
)

export default ErrorPage
